import {
  FeedstockBmpPotentialAI2,
  FeedstockBmpPotentialAI2PropName
} from '../../../../../models/project/feedstock/feedstock-bmp-potential/feedstock-bmp-potential-type-models/feedstock-bmp-potential-AI2.model';
import { ValidationInterface } from '../../../validation.interface';
import { ProjectValidationUnit } from '../../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../../unit-value.validation';

export class FeedstockBmpPotentialAI2Validation implements ValidationInterface {
  /** The current BMP potential nutrition obj that is being validated */
  bmpPotentialAI2: FeedstockBmpPotentialAI2;

  /**
   * Sets the BMP potential nutrition obj that will be used for validation
   * @param bmpPotentialNutrition will be used to set the current BMP potential nutrition obj
   */
  constructor(bmpPotentialAI2: FeedstockBmpPotentialAI2) {
    if (!bmpPotentialAI2) throw Error('invalid BMP potential AI2 provided for validation');
    this.bmpPotentialAI2 = new FeedstockBmpPotentialAI2(bmpPotentialAI2);
  }

  /**
   * Get a validation unit containing the validation data for the current BMP potential nutrition obj
   * @param validationUnit, if provided will have the validation for the current BMP potential nutrition
   * added to it. If it is not provided a new validation unit will be returned.
   */
  getValidation(validationUnit = new ProjectValidationUnit()): ProjectValidationUnit {
    if (!this.bmpPotentialAI2) throw Error('unable to validation BMP potential');
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialAI2.lipidFat).getValidation(),
      FeedstockBmpPotentialAI2PropName.lipidFat
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialAI2.protein).getValidation(),
      FeedstockBmpPotentialAI2PropName.protein
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialAI2.ndf).getValidation(),
      FeedstockBmpPotentialAI2PropName.ndf
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialAI2.adf).getValidation(),
      FeedstockBmpPotentialAI2PropName.adf
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialAI2.adl).getValidation(),
      FeedstockBmpPotentialAI2PropName.adl
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialAI2.nonFibreCarbohydrate).getValidation(),
      FeedstockBmpPotentialAI2PropName.nonFibreCarbohydrate
    );
    if (this.bmpPotentialAI2.ch4ContentEnabled) {
      validationUnit.addModuleResults(
        new UnitValueValidation(this.bmpPotentialAI2.ch4Content).getValidation(),
        FeedstockBmpPotentialAI2PropName.ch4Content
      );
    }

    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current BMP potential AI2 obj is valid
   */
  isValid(): boolean {
    return this.getValidation().isValid;
  }
}
